import type { FetchError } from 'ofetch';
import type { NuxtApp } from '#app';

export const noop = () => {};

export const isNumeric = (num: unknown) =>
  (typeof num === 'number' || (typeof num === 'string' && num.trim() !== ''))
  && !isNaN(num as number);

export const getCachedPayload = (key: string, nuxtApp: NuxtApp) => nuxtApp.payload.data[key];

export const range = (length: number) => Array.from({ length }, (_value, index) => index);

export const getFetchErrorMessage = (error: unknown) => {
  if (isFetchError(error)) {
    if (error.data && typeof error.data === 'object' && 'message' in error.data) {
      return String((error.data as { message: unknown }).message);
    }

    return `Request failed with status ${error.status} (${error.statusText || 'Unknown error'})`;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'An unexpected error occurred.';
};

export const isFetchError = (error: unknown): error is FetchError =>
  typeof error === 'object'
  && error !== null
  && 'status' in error
  && 'statusText' in error;
